import Vue from "vue";

let eventHub = new Vue();
export default eventHub;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/facility/FacilityEventHub.ts